import * as types from './actionTypes';
import grupoTratamentoUFClassificacaoApi from '../api/grupoTratamentoUFClassificacaoApi'


export function ObterGrupoTratamentoUFClassificacaoPorGrupoUFSucess(grupoTratamentoUFClassificacao) {
    
    return { type: types.OBTER_GRUPOTRATAMENTO_UF_CLASSIFICACOES, grupoTratamentoUFClassificacao }
}

export function ObterGrupoTratamentoUFClassificacaoPorGrupoUF(parametros) {
    return function (dispatch) {
        return grupoTratamentoUFClassificacaoApi.ObterGrupoTratamentoUFClassificacaoPorGrupoUF(parametros).then(resultado => {
            
            dispatch(ObterGrupoTratamentoUFClassificacaoPorGrupoUFSucess(resultado));
        }).catch(error => {
            //debugger
            window.location.href = 'https://sebrae.com.br/sites/PortalSebrae/faleconosco';
            throw (error);
            
        });
    };
}




/** WEBPACK FOOTER **
 ** ./src/components/actions/grupoTratamentoUFClassificacaoActions.js
 **/